import { render, staticRenderFns } from "./star-rating.vue?vue&type=template&id=1d64b278&"
import script from "./star-rating.vue?vue&type=script&lang=js&"
export * from "./star-rating.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d64b278')) {
      api.createRecord('1d64b278', component.options)
    } else {
      api.reload('1d64b278', component.options)
    }
    module.hot.accept("./star-rating.vue?vue&type=template&id=1d64b278&", function () {
      api.rerender('1d64b278', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2VgYzXslAgqWz/JS/comp/star-rating.vue"
export default component.exports